module.exports = "<ilp-oauth-login [title]=\"'Welcome to MSGM Dashboard'\" [logoutReason]=\"_logoutReason\" ></ilp-oauth-login>\n"